import * as types from "./actionTypes";
import * as documentsApi from "../../_api/documentsApi";
import { beginApiCall, apiCallError } from "./apiStatusActions";

export function loadDocumentsSuccess(documents) {
  return { type: types.LOAD_DOCUMENTS_SUCCESS, documents };
}

// export function loadToDoListSuccess(toDoList) {
//   return { type: types.LOAD_TODO_LIST_SUCCESS, toDoList };
// }

export function unloadReportSuccess() {
  return { type: types.UNLOAD_REPORT_SUCCESS };
}

// export function loadCompletedListSuccess(completedList) {
//   return { type: types.LOAD_COMPLETED_LIST_SUCCESS, completedList };
// }

export function loadCompletedDocumentSuccess(completedDocument) {
  return { type: types.LOAD_COMPLETED_DOCUMENT_SUCCESS, completedDocument };
}

export function loadReportSignaturesSuccess(reportSignatures) {
  return { type: types.LOAD_REPORTSIGNATURES_SUCCESS, reportSignatures };
}

export function saveReportSignatureOptimistic(userSignature) {
  return { type: types.SAVE_REPORTSIGNATURE_OPTIMISTIC, userSignature };
}

export function saveCompletedReportOptimistic(completedReportID) {
  return { type: types.SAVE_COMPLETED_REPORT_OPTIMISTIC, completedReportID };
}

export function resetCompletedDocumentSuccess() {
  return { type: types.RESET_COMPLETED_DOCUMENT_SUCCESS };
}

export function loadReportSuccess(report) {
  return { type: types.LOAD_REPORT_SUCCESS, report };
}

export function loadDocuments(clientId, userID, languageID) {
  return function (dispatch) {
    dispatch(beginApiCall());
    return documentsApi
      .getDocuments(clientId, userID, languageID)
      .then((documents) => {
        if (documents.length === 0) {
          dispatch(loadDocumentsSuccess([{ CurrentState: "None" }]));
        } else {
          dispatch(loadDocumentsSuccess(documents));
        }
      })
      .catch((error) => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}

export function loadReportSignatures() {
  return function (dispatch) {
    dispatch(beginApiCall());
    return documentsApi
      .loadReportSignatures()
      .then((reportSignatures) => {
        if (reportSignatures.length === 0) {
          dispatch(loadReportSignaturesSuccess([{ CurrentState: "None" }]));
        } else {
          //Remove any inactive signatures if they got through
          const filteredReportSignatures = reportSignatures.filter(
            (x) => x.active === true
          );
          if (filteredReportSignatures.length === 0) {
            dispatch(loadReportSignaturesSuccess([{ CurrentState: "None" }]));
          } else {
            dispatch(loadReportSignaturesSuccess(filteredReportSignatures));
          }
        }
      })
      .catch((error) => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}

export function saveReportSignature(params) {
  return function (dispatch) {
    dispatch(beginApiCall());
    return documentsApi
      .saveReportSignature(params)
      .then(() => {
        dispatch(saveReportSignatureOptimistic(params.reportSignatureId));
      })
      .catch((error) => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}

export function loadCompletedDocument(filePath) {
  return function (dispatch) {
    dispatch(beginApiCall());
    return documentsApi
      .loadCompletedDocument(filePath)
      .then((completedDocumentBody) => {
        let completedDocument = [completedDocumentBody];
        dispatch(loadCompletedDocumentSuccess(completedDocument));
      })
      .catch((error) => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}

export function resetCompletedDocument() {
  return function (dispatch) {
    dispatch(resetCompletedDocumentSuccess());
  };
}

export function loadReport(params) {
  return function (dispatch) {
    dispatch(beginApiCall());
    return documentsApi
      .loadReport(params)
      .then((report) => {
        if (report.length === 0) {
          dispatch(loadReportSuccess([{ CurrentState: "None" }]));
        } else {
          dispatch(loadReportSuccess(report));
        }
      })
      .catch((error) => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}

export function unloadReport() {
  return function (dispatch) {
    dispatch(unloadReportSuccess());
  };
}

export function saveCompletedReport(params) {
  return function (dispatch) {
    dispatch(beginApiCall());
    return documentsApi
      .saveCompletedReport(params)
      .then(() => {
        dispatch(saveCompletedReportOptimistic(params.reportID));
      })
      .catch((error) => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}

export function loadTemplate(languageId, file) {
  return function (dispatch) {
    dispatch(beginApiCall());
    return documentsApi
      .getTemplate(languageId, file)
      .then((template) => {
        return template;
      })
      .catch((error) => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}
